import { useSelector } from 'react-redux';
import React from 'react';
import { FormattedMessage } from 'react-intl';

const page = 'verifyUniqueCodePage';

export function VerifyItemIdentifierPage() {
  const userSlice = useSelector((state) => state.auth.user);

  return (
    <div className="verify-unique-code page">
      {userSlice.itemAssignmentCodeAuthenticationStatus === 'Invalid' && (
        <div className="ui card">
          <div className="ui one column grid content custom-card">
            <div>
              <FormattedMessage
                id={`${page}.invalidLink`}
                defaultMessage="Access link you have provided is incorrect/expired. Please check the link and try again."
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
